import { parsePropertyLines } from "./parse-properties";

interface BoldEntry {
  id: string;
  properties: Record<string, unknown>;
}

const BOLD_ENTRY = /^\s*-\s+\*\*([a-zA-Z0-9_\-./]+)\*\*\s*$/;
const BOLD_ENTRY_INLINE = /^\s*-\s+\*\*([a-zA-Z0-9_\-./]+)\*\*\s*[:.\-—]\s*(.+)$/;

export function parseBoldEntries(body: string): BoldEntry[] {
  const lines = body.split("\n");
  const entries: BoldEntry[] = [];
  let i = 0;

  while (i < lines.length) {
    const line = lines[i];
    if (line === undefined) {
      i += 1;
      continue;
    }

    const inlineMatch = line.match(BOLD_ENTRY_INLINE);
    const standaloneMatch = line.match(BOLD_ENTRY);

    if (standaloneMatch || inlineMatch) {
      const id = (standaloneMatch?.[1] ?? inlineMatch?.[1] ?? "").trim();
      const remainder = inlineMatch?.[2]?.trim();
      const properties: Record<string, unknown> = {};
      if (remainder) properties.label = remainder.replace(/^"|"$/g, "");

      const propertyLines: string[] = [];
      let j = i + 1;
      while (j < lines.length) {
        const next = lines[j];
        if (next === undefined) break;
        if (next.trim().length === 0) {
          propertyLines.push(next);
          j += 1;
          continue;
        }
        if (BOLD_ENTRY.test(next) || BOLD_ENTRY_INLINE.test(next)) break;
        if (/^[#-]/.test(next) && !next.startsWith("  -") && !next.startsWith("    ")) {
          if (next.startsWith("- ") && !next.match(/^\s{2,}/)) break;
        }
        propertyLines.push(next);
        j += 1;
      }
      const { properties: parsed } = parsePropertyLines(propertyLines, 2);
      Object.assign(properties, parsed);
      entries.push({ id, properties });
      i = j;
      continue;
    }

    i += 1;
  }
  return entries;
}
